import { render, staticRenderFns } from "./promptList.vue?vue&type=template&id=87d6b1be&scoped=true&"
import script from "./promptList.vue?vue&type=script&lang=js&"
export * from "./promptList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87d6b1be",
  null
  
)

export default component.exports